
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bdOyr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $172fdc5b4f483e55$export$2e2bcd8739ae039);
/* eslint-disable jira/import-whitelist */ 
var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");

var $iR3GG = parcelRequire("iR3GG");

var $dZw8H = parcelRequire("dZw8H");

var $4su49 = parcelRequire("4su49");

var $eNf8a = parcelRequire("eNf8a");

var $PK2Tm = parcelRequire("PK2Tm");
const $172fdc5b4f483e55$var$sessionStorage = (0, $eNf8a.createSessionStorageProvider)('', false);
const $172fdc5b4f483e55$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
// PREFETCH ONLY FOR ISSUE VIEW AND PROJECTS-DIRECTORY
// TO-DO: Add it in constant file
const $172fdc5b4f483e55$var$PREFETCH_USER_LOCATIONS = new Set([
    `${'directories'}:${'projects-directory'}`,
    `${'issue'}:${'issue'}`
]);
// check if the apps loaded on last page contain any app on which prefetching was done.
const $172fdc5b4f483e55$var$isPrefetchRoute = (lastUserLocation)=>$172fdc5b4f483e55$var$PREFETCH_USER_LOCATIONS.has(lastUserLocation ?? '');
const $172fdc5b4f483e55$var$buildWebResourcesPayload = (resourceArr)=>{
    const payload = {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        r: [],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        c: [],
        xc: [
            $172fdc5b4f483e55$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    resourceArr.forEach((resource)=>{
        if (resource.indexOf('wrc!') !== -1) payload.c.push(resource.slice(4));
        else if (resource.indexOf('wr!') !== -1) payload.r.push(resource.slice(3));
        else payload.r.push(resource);
    });
    return payload;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $172fdc5b4f483e55$var$generateScriptTags = (response)=>{
    let resourceHtml = `
    <script type="text/javascript" data-defer-skip>
        window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
        WRM._unparsedData = JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))});
        WRM._unparsedErrors = JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))});
        if(window.WRM._dataArrived)window.WRM._dataArrived();
    </script>
    `;
    // @ts-expect-error - TS7006 - Parameter 'resource' implicitly has an 'any' type.
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};
const $172fdc5b4f483e55$var$getResourceUrl = ()=>{
    let url = null;
    try {
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
            url = JSON.parse($172fdc5b4f483e55$var$sessionStorage.get('classicBatchUrl'));
            // remove the cached value so that it can be used only one time
            $172fdc5b4f483e55$var$sessionStorage.remove('classicBatchUrl');
        } else {
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            url = JSON.parse(window.sessionStorage.getItem('classicBatchUrl'));
            // remove the cached value so that it can be used only one time
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.sessionStorage.removeItem('classicBatchUrl');
        }
    } catch  {
        return null;
    }
    return url;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$172fdc5b4f483e55$export$2e2bcd8739ae039 = async ({ match: match, route: route }, _context)=>{
    const boardId = match.query.rapidView ?? match.params.boardId;
    if (!boardId) return null;
    try {
        const contexts = (0, $PK2Tm.getRequiredResourceList)(route ? route.name : null);
        if (!false && (route?.name === 'rapidboard-board' || route?.name === 'rapidboard-board-embed' || route?.name === 'servicedesk-boards' || route?.name === 'servicedesk-queues-custom-board' || route?.name === 'servicedesk-queues-practice-custom-board')) {
            // get all the apps loaded in last visited page
            const lastUserLocation = (0, $dZw8H.getSpaStateLastUserLocation)();
            if ($172fdc5b4f483e55$var$isPrefetchRoute(lastUserLocation)) {
                // Get the prefetched batch Url from the session Storage
                const batchUrl = $172fdc5b4f483e55$var$getResourceUrl();
                if (batchUrl) {
                    await (0, $4su49.asyncWrmRequireWithPrefetch)(contexts, batchUrl);
                    (0, $2YZCu.default).safeInfoWithoutCustomerData('spa.view.routes.classic-projects.wrm.prefetch', 'prefetch success');
                    return {
                        contexts: contexts
                    };
                }
            }
        }
        if (!false) {
            await (0, $4su49.asyncWrmRequire)(contexts);
            return {
                contexts: contexts
            };
        }
        const payload = $172fdc5b4f483e55$var$buildWebResourcesPayload(contexts);
        const res = await (0, $7f4tk.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
        return {
            ...res,
            contexts: contexts,
            scriptTags: $172fdc5b4f483e55$var$generateScriptTags(res)
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.classic-projects.work-all-data.getData',
            message: 'An error was thrown while prefetching work all data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("4su49", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $ae90ef6541667ecb$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $ae90ef6541667ecb$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $8JNtu.wrmRequire)(resourcesToRequire);
const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $5Ik5Y.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});
parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});
parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});

parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});


parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});



parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});



parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});




//# sourceMappingURL=async-resource-rapidboards-wrm-bundle.4068d970.js.map
